import { safeGet } from '../../../utils/safeGet'
import { get as _get, post as _post, fetchCustomMethod } from '../../../utils/fetcher'

export default {
  namespaced: true,

  state: {
    pagination: {
      perPage: 25,
      currentPage: 1,
      items: 0,
    },
    sortingValue: '',
    searchBarValue: '',
    isinFilter: '',
    statusFilter: null,
    outcomeFilter: null,
    efficiencyTestsList: [],
  },

  mutations: {
    setPagination(state, data) {
      state.pagination = data
    },
    setSortingValue(state, data) {
      state.sortingValue = data
    },
    setSearchBarValue(state, data) {
      state.searchBarValue = data
    },
    setIsinFilter(state, data) {
      state.isinFilter = data
    },
    setStatusFilter(state, data) {
      state.statusFilter = data
    },
    setOutcomeFilter(state, data) {
      state.outcomeFilter = data
    },
    setPaginationPerPage(state, data) {
      state.pagination.perPage = data
    },
    setPaginationCurrentPage(state, data) {
      state.pagination.currentPage = data
    },
    setEfficiencyTestsList(state, data) {
      state.efficiencyTestsList = data
    },
  },

  actions: {
    loadEfficiencyTests({ commit, getters, dispatch }) {
      dispatch('efficiencyTestsCommon/setLoading', true, { root: true })
      const payload = {
        Sf: getters.getSearchBarValue,
        Isin: getters.getIsinFilter || null,
        Status: getters.getStatusFilter,
        Outcome: getters.getOutcomeFilter,
        Page: getters.getPagination.currentPage,
        Size: getters.getPagination.perPage,
        Sort: getters.getSortingValue,
      }
      return new Promise((resolve, reject) => {
        _post('/api/efficiencyTests/search', payload)
          .then((data) => {
            commit('setPagination', {
              perPage: data.paging.pageSize,
              currentPage: data.paging.pageIndex,
              items: data.paging.totalItems,
            })
            const efficiencyTests = (data.efficiencyTests || []).map((item) => ({
              ...item,
              scoringProfileId: item.id,
            }))
            commit('setEfficiencyTestsList', efficiencyTests)
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            dispatch('efficiencyTestsCommon/setLoading', false, { root: true })
          })
      })
    },

    // No reload here: EfficiencyTestsTable.vue emits `refresh` and each host reloads its own list
    // (the full list page, or ProductEfficiencyTests.vue's ISIN-scoped one).
    deleteScoringProfile({}, profileId) {
      return fetchCustomMethod(`/api/efficiencyTests/${profileId}`, 'DELETE', {})
    },

    executeEfficiencyTest({}, profileId) {
      // keep403: a refusal of the permission is told by the caller (utils/executeRejection.js), not by the error page.
      return _post(`/api/efficiencyTests/${profileId}/execute`, undefined, { keep403: true })
    },

    resetState({ state }) {
      state.pagination = {
        perPage: 25,
        currentPage: 1,
        items: 0,
      }
      state.sortingValue = ''
      state.searchBarValue = ''
      state.isinFilter = ''
      state.statusFilter = null
      state.outcomeFilter = null
      state.efficiencyTestsList = []
    },
  },

  getters: {
    getPagination: (state) => {
      return safeGet(() => state.pagination, {
        perPage: 25,
        currentPage: 1,
        items: 0,
      })
    },
    getSortingValue: (state) => {
      return safeGet(() => state.sortingValue, '')
    },
    getSearchBarValue: (state) => {
      return safeGet(() => state.searchBarValue, '')
    },
    getIsinFilter: (state) => {
      return safeGet(() => state.isinFilter, '')
    },
    getStatusFilter: (state) => {
      return safeGet(() => state.statusFilter, null)
    },
    getOutcomeFilter: (state) => {
      return safeGet(() => state.outcomeFilter, null)
    },
    getEfficiencyTestsList: (state) => {
      return safeGet(() => state.efficiencyTestsList, [])
    },
  },
}
